import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

const Foot = () => {
  return (
    <footer className="footer bg-dark text-light py-4 z-1">
      <Container>
        <Row>
          {/* Company Info */}
          <Col md={4} className="mb-4">
            <h5 className="navbar-brand text-white">IFMF</h5>
            <p>
              Pioneering in interest-free mortgage fund.
            </p>
          </Col>

          {/* Contact Info */}
          <Col md={4} className="mb-4">
            <h5>Contact</h5>
            <p>
              <strong>Address:</strong> Florida, USA
              <br />
              <strong>Email:</strong> info@ifmf.com
            </p>
            <div className="text-center">
              <a href="https://facebook.com" className="text-light me-3">
                <FaFacebook size={24} />
              </a>
              <a href="https://twitter.com" className="text-light me-3">
                <FaTwitter size={24} />
              </a>
              <a href="https://instagram.com" className="text-light me-3">
                <FaInstagram size={24} />
              </a>
              <a href="https://linkedin.com" className="text-light">
                <FaLinkedin size={24} />
              </a>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} IF Holdings, Inc. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Foot;
